import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../hooks/apiClient";
import TextSpinner from "../../components/UI/Spinner/TextSpinner";
import ConsultaContribuinteModal from "./ConsultaContribuinteModal";
import DateTime from "../../components/Formatters/DateTime";

const ConsultaContribuinte = ({ dadosOs }) => {
  const [contribuinte, setContribuinte] = useState({});
  const [showContribuinte, setShowContribuinte] = useState({
    show: false,
    body: null,
    context: null,
  });
  const {
    request: requesContribuinte,
    data: dataContribuinte,
    errors: errorsContribuinte,
    isLoading: submitIsLoading,
  } = useApiClient();
  const {
    request: requestDownload,
    data: dataDownload,
    errors: errorDownload,
    isLoading: downloadIsLoading,
  } = useApiClient();

  useEffect(() => {
    requesContribuinte(apiRoutes.fiscalizacao.ordemservico.consultaContribuinteIcms, { cnpj: dadosOs?.cnpjCpf });
  }, [requesContribuinte, dadosOs.cnpjCpf]);

  useEffect(() => {
    if (dataContribuinte) {
      setContribuinte(dataContribuinte?.result?.model);
    }

    if (errorsContribuinte) {
      toast.error(errorsContribuinte.message);
    }
  }, [contribuinte, errorsContribuinte, submitIsLoading, dataContribuinte, showContribuinte]);

  // download
  useEffect(() => {
    if (dataDownload) {
      const file = new Blob([dataDownload], { type: "application/pdf" });
      const url = URL.createObjectURL(file);

      window.open(url, "", "width=800,height=800").print();
    }
    if (errorDownload) {
      toast.error(errorDownload.message);
    }
  }, [dataDownload, errorDownload]);

  const baixarDocumento = (value) => {
    const parametros = { cnpj: value };
    requestDownload(apiRoutes.fiscalizacao.ordemservico.downloadContribuinteIcms, parametros);
  };

  const {
    identificacaoModel,
    tipoUnidadeModel,
    formaAtuacaoModels,
    obrigatoriedadeEfdModels,
    regionalModel,
    contadorModel,
    responsavelCnpjModels,
    cnaeSecundariaModels,
    representanteModels,
    credenciamentoModels,
    outrasEmpresasModels,
    ocorrenciasFiscaisModels,
    situacaoAtualizadaModels,
    periodoEfdModels,
  } = contribuinte;

  const tam = cnaeSecundariaModels?.length;

  let tamanho = 0;
  if (cnaeSecundariaModels !== undefined && tam > 10) {
    tamanho = 24 * 10;
  } else {
    tamanho = 24 * tam;
  }

  return (
    <>
      <ConsultaContribuinteModal
        title="Consultar Histórico"
        show={showContribuinte.show}
        body={showContribuinte.body}
        loadingConfirmationAction={showContribuinte.loadingConfirmationAction}
        size="xl"
        closeHandler={() => setShowContribuinte({ show: false })}
      >
        <div>
          {obrigatoriedadeEfdModels?.map(
            (obj) =>
              obj?.obrigatoriedade !== undefined &&
              obj?.obrigatoriedade === 0 && (
                <Form.Label>{`Não há período de obrigatoriedade cadastrado para esse CNPJ: ${identificacaoModel?.cnpj} - 
                Inscrição Estadual: ${identificacaoModel?.inscricao}`}</Form.Label>
              ),
          )}
        </div>
        <div>
          {obrigatoriedadeEfdModels?.map(
            (obrigatoriedade) =>
              obrigatoriedade?.obrigatoriedade !== undefined &&
              obrigatoriedade?.obrigatoriedade === 1 && (
                <Row>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Data Inicial</th>
                        <th>Motivo</th>
                        <th>Data Final</th>
                        <th>Motivo</th>
                        <th>Perfil</th>
                      </tr>
                    </thead>
                    <tbody>
                      {periodoEfdModels?.map((obj) => (
                        <tr key={Math.random()}>
                          <td>{obj.dtInicio}</td>
                          <td>{obj.txInicio}</td>
                          <td>{obj.dtFinal}</td>
                          <td>{obj.txFinal}</td>
                          <td>{obj.tpPerfil}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Row>
              ),
          )}
        </div>
      </ConsultaContribuinteModal>
      <Row>
        <div className="col-sm-12">
          <div className="row">
            <div className="col-sm-6 text-left">
              <h4>Consulta Contribuinte - Sefaz/RN</h4>
            </div>
            <div className="col-sm-6 text-right">
              {downloadIsLoading ? (
                <TextSpinner />
              ) : (
                <Button
                  variant="primary"
                  className="font-weight-bold text-center tamanho-fonte-botao"
                  onClick={() => baixarDocumento(dadosOs.cnpjCpf)}
                >
                  Visualizar Impressão
                </Button>
              )}
              <div className="row">
                <br />
              </div>
            </div>
          </div>
        </div>
      </Row>
      <Row>
        <div className="col-lg-12">
          <div className="card shadow mb-1">
            <div className="card-header">
              <b>Identificação</b>
            </div>
            <div className="card-body">
              <Row>
                <div className="col-sm-12">
                  <Row>
                    <Form.Group as={Col} sm={12} md={3}>
                      <Form.Label>Razão Social</Form.Label>
                      <div className="form-inline">
                        <Form.Label>{identificacaoModel?.nmFormal}</Form.Label>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Nome Fantasia</Form.Label>
                      <div className="form-inline">
                        <Form.Label>{identificacaoModel?.nmFantasia}</Form.Label>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>CNPJ</Form.Label>
                      <div className="form-inline">
                        <Form.Label>{identificacaoModel?.cnpj}</Form.Label>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Inscrição Estadual</Form.Label>
                      <div className="form-inline">
                        <Form.Label>{identificacaoModel?.inscricao}</Form.Label>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={3}>
                      <Form.Label>Natureza Jurídica</Form.Label>
                      <div className="form-inline">
                        <Form.Label>{identificacaoModel?.dsNaturezaJuridica}</Form.Label>
                      </div>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} sm={12} md={3}>
                      <Form.Label>CNAE Primário</Form.Label>
                      <div className="form-inline">
                        <Form.Label>{identificacaoModel?.cnaePrimario}</Form.Label>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Tipo de Contribuinte</Form.Label>
                      <div className="form-inline">
                        <Form.Label>{identificacaoModel?.dsTipoContribuinte}</Form.Label>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Tipo de Unidade</Form.Label>
                      <div className="form-inline">
                        <Form.Label>{tipoUnidadeModel?.tipoUnidade}</Form.Label>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Regime de Pagamento</Form.Label>
                      <div className="form-inline">
                        <Form.Label>{identificacaoModel?.dsFormaPagamento}</Form.Label>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={3}>
                      <Form.Label>Forma de Atuação</Form.Label>
                      <div className="form-inline">
                        {formaAtuacaoModels?.map(
                          (obj) => obj.formaAtuacao !== undefined && <Form.Label>{obj.formaAtuacao}</Form.Label>,
                        )}
                      </div>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} sm={12} md={12}>
                      <Form.Label>CNAE Secundário</Form.Label>
                      <div className="col-sm-12">
                        <div className="scrollbar" style={{ height: tamanho }}>
                          {cnaeSecundariaModels?.map((item) => (
                            <div className="row">{item?.cnaeSec}</div>
                          ))}
                        </div>
                      </div>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Início da Atividade</Form.Label>
                      <div className="form-inline">
                        <Form.Label>{identificacaoModel?.inicioatividade}</Form.Label>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Situação Cadastral</Form.Label>
                      <div className="form-inline">
                        <Form.Label>{identificacaoModel?.situacao}</Form.Label>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={3}>
                      <Form.Label>Cadastro atualizado</Form.Label>
                      <div className="form-inline">
                        <Form.Label>
                          <DateTime value={identificacaoModel?.atualizacaoCadastral} />
                        </Form.Label>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={3}>
                      <Form.Label>Obrigado no Envio de Arquivo EFD</Form.Label>
                      <div className="form-inline">
                        <div className="col-lg-1">
                          {obrigatoriedadeEfdModels?.map(
                            (obj) => obj.envioEfd !== undefined && <Form.Label>{obj.envioEfd}</Form.Label>,
                          )}
                        </div>
                        <br />
                        <div className="col-lg-8">
                          <Button
                            variant="primary"
                            className="font-weight-bold text-center tamanho-fonte-botao"
                            onClick={() =>
                              setShowContribuinte({
                                show: true,
                                body: null,
                                context: null,
                              })
                            }
                          >
                            Consultar Histórico
                          </Button>
                        </div>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Produtor Rural de Pequeno Porte</Form.Label>
                      <div className="form-inline">{identificacaoModel?.fgProdutorRuralCpf}</div>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} sm={12} md={6}>
                      <Form.Label>Situação Cadastal Atualizada</Form.Label>
                      <div className="form-inline">
                        {situacaoAtualizadaModels?.map(
                          (obj) => obj.pdtinicial !== undefined && <Form.Label>{obj.pdtinicial}</Form.Label>,
                        )}
                      </div>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} sm={12} md={5}>
                      <Form.Label>Observação</Form.Label>
                      <div className="form-inline">
                        {situacaoAtualizadaModels?.map(
                          (obj) => obj.pobs !== undefined && <Form.Label>{obj.pobs}</Form.Label>,
                        )}
                      </div>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Detalhe da Inscrição</Form.Label>
                      <div className="form-inline">{identificacaoModel?.detalheInscricao}</div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>NIRE</Form.Label>
                      <div className="form-inline">{identificacaoModel?.nire}</div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Registro na Junta</Form.Label>
                      <div className="form-inline">{identificacaoModel?.registroNaJunta}</div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Expectativa Receita Anual (R$)</Form.Label>
                      <div className="form-inline">
                        {(identificacaoModel?.expectativaReceitaAnual || 0).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Capital Integralizado (R$)</Form.Label>
                      <div className="form-inline">
                        {(identificacaoModel?.capitalIntegralizado || 0).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={2}>
                      <Form.Label>Capital Social (R$)</Form.Label>
                      <div className="form-inline">
                        {(identificacaoModel?.capitalSocial || 0).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </div>
                    </Form.Group>
                  </Row>
                </div>
              </Row>
            </div>
          </div>
        </div>
      </Row>
      <Row>
        <div className="col-lg-12">
          <div className="card shadow mb-1">
            <div className="card-header">
              <b>Endereço Comercial</b>
            </div>
            <div className="card-body">
              <Row>
                <Form.Group as={Col} sm={12} md={3}>
                  <Form.Label>Endereço Completo</Form.Label>
                  <div className="form-inline">
                    <Form.Label>{identificacaoModel?.endereco}</Form.Label>
                  </div>
                </Form.Group>
                <Form.Group as={Col} sm={12} md={3}>
                  <Form.Label>Distrito</Form.Label>
                  <div className="form-inline">
                    <Form.Label>{identificacaoModel?.distrito}</Form.Label>
                  </div>
                </Form.Group>
                <Form.Group as={Col} sm={12} md={3}>
                  <Form.Label>Complemento</Form.Label>
                  <div className="form-inline">
                    <Form.Label>{identificacaoModel?.complemento}</Form.Label>
                  </div>
                </Form.Group>
                <Form.Group as={Col} sm={12} md={3}>
                  <Form.Label>Referência</Form.Label>
                  <div className="form-inline">
                    <Form.Label>{identificacaoModel?.referencia}</Form.Label>
                  </div>
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} sm={12} md={3}>
                  <Form.Label>Regional</Form.Label>
                  <div className="form-inline">
                    <Form.Label>{regionalModel?.sgOrgao}</Form.Label>
                  </div>
                </Form.Group>
                <Form.Group as={Col} sm={12} md={6}>
                  <Form.Label>E-mail</Form.Label>
                  <div className="form-inline">
                    <Form.Label>{identificacaoModel?.email}</Form.Label>
                  </div>
                </Form.Group>
                <Form.Group as={Col} sm={12} md={3}>
                  <Form.Label>Celular</Form.Label>
                  <div className="form-inline">
                    <Form.Label>{identificacaoModel?.celular}</Form.Label>
                  </div>
                </Form.Group>
              </Row>
            </div>
          </div>
        </div>
      </Row>
      <Row>
        <div className="col-lg-12">
          <div className="card shadow mb-1">
            <div className="card-header">
              <b>Endereço Correspondência</b>
            </div>
            <div className="card-body">
              <div className="col-sm-12">
                <Row>
                  <Form.Group as={Col} sm={12} md={3}>
                    <Form.Label>Endereço</Form.Label>
                    <div className="form-inline">
                      <Form.Label>{identificacaoModel?.enderecoCorrespondencia}</Form.Label>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} sm={12} md={3}>
                    <Form.Label>Distrito</Form.Label>
                    <div className="form-inline">
                      <Form.Label>{identificacaoModel?.distritoCorresp}</Form.Label>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} sm={12} md={3}>
                    <Form.Label>Complemento</Form.Label>
                    <div className="form-inline">
                      <Form.Label>{identificacaoModel?.complementoCorrespondencia}</Form.Label>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} sm={12} md={3}>
                    <Form.Label>Referência</Form.Label>
                    <div className="form-inline">
                      <Form.Label>{identificacaoModel?.referenciaCorresp}</Form.Label>
                    </div>
                  </Form.Group>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Row>
      <Row>
        <div className="col-lg-12">
          <div className="card shadow mb-1">
            <div className="card-header">
              <b>Contador</b>
            </div>
            <div className="card-body">
              <div className="col-sm-12">
                <Row>
                  <Form.Group as={Col} sm={12} md={3}>
                    <Form.Label>Nome do Contador</Form.Label>
                    <div className="form-inline">
                      <Form.Label>{contadorModel?.contator}</Form.Label>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} sm={12} md={2}>
                    <Form.Label>CRC/UF-Tipo</Form.Label>
                    <div className="form-inline">
                      <Form.Label>{contadorModel?.crc}</Form.Label>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} sm={12} md={5}>
                    <Form.Label>Endereço Contador</Form.Label>
                    <div className="form-inline">
                      <Form.Label>{contadorModel?.enderecoContator}</Form.Label>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} sm={12} md={2}>
                    <Form.Label>Telefone</Form.Label>
                    <div className="form-inline">
                      <Form.Label>{contadorModel?.telefoneContator}</Form.Label>
                    </div>
                  </Form.Group>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Row>
      <Row>
        <div className="col-lg-12">
          <div className="card shadow mb-1">
            <div className="card-header">
              <b>Responsável perante a Receita Federal</b>
            </div>
            <div className="card-body">
              <div className="col-sm-12">
                <Row>
                  <div className="col-sm-12">
                    {responsavelCnpjModels?.map((obj) => (
                      <Row>
                        <Form.Group as={Col} sm={12} md={3}>
                          <Form.Label>Responsável</Form.Label>
                          <div className="form-inline">
                            <Form.Label>{obj?.nmResponsavel}</Form.Label>
                          </div>
                        </Form.Group>
                        <Form.Group as={Col} sm={12} md={2}>
                          <Form.Label>CPF</Form.Label>
                          <div className="form-inline">
                            <Form.Label>{obj?.cpf}</Form.Label>
                          </div>
                        </Form.Group>
                        <Form.Group as={Col} sm={12} md={5}>
                          <Form.Label>Endereço</Form.Label>
                          <div className="form-inline">
                            <Form.Label>{obj?.endereco}</Form.Label>
                          </div>
                        </Form.Group>
                      </Row>
                    ))}
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Row>
      <Row>
        <div className="col-lg-12">
          <div className="card shadow mb-1">
            <div className="card-header">
              <b>Representantes</b>
            </div>
            <div className="card-body">
              <div className="col-sm-12">
                <Row>
                  <div className="col-sm-12">
                    <Row>
                      {representanteModels?.map((obj) => (
                        <div className="col-sm-12">
                          <div className="row">
                            <Form.Group as={Col} sm={12} md={3}>
                              <div className="form-inline">
                                <Form.Label>Nome</Form.Label>
                              </div>
                              <div className="form-inline">
                                <Form.Label>{obj?.representante}</Form.Label>
                              </div>
                            </Form.Group>
                            <Form.Group as={Col} sm={12} md={2}>
                              <div className="form-inline">
                                <Form.Label>CPF/CNPJ</Form.Label>
                              </div>
                              <div className="form-inline">
                                <Form.Label>{obj?.cnpfCnpj}</Form.Label>
                              </div>
                            </Form.Group>
                            <Form.Group as={Col} sm={12} md={7}>
                              <div className="form-inline">
                                <Form.Label>Endereço</Form.Label>
                              </div>
                              <div className="form-inline">
                                <Form.Label>{obj?.endereco}</Form.Label>
                              </div>
                            </Form.Group>
                            <div className="col-sm-12">
                              <Row>
                                <Form.Group as={Col} sm={12} md={3}>
                                  <Form.Label>Qualificação</Form.Label>
                                  <div className="form-inline">
                                    <Form.Label>{obj?.qualificacao}</Form.Label>
                                  </div>
                                </Form.Group>
                                <Form.Group as={Col} sm={12} md={2}>
                                  <Form.Label>Início</Form.Label>
                                  <div className="form-inline">
                                    <Form.Label>{obj?.dtInicioQualificacao}</Form.Label>
                                  </div>
                                </Form.Group>
                                <Form.Group as={Col} sm={12} md={3}>
                                  <Form.Label>Fim</Form.Label>
                                  <div className="form-inline">
                                    <Form.Label>{obj?.dtFimQualificacao}</Form.Label>
                                  </div>
                                </Form.Group>
                                <Form.Group as={Col} sm={12} md={4}>
                                  <Form.Label>Porcentagem participação</Form.Label>
                                  <div className="form-inline">
                                    <Form.Label>{obj?.nuPorcentagemParticipacao}</Form.Label>
                                  </div>
                                </Form.Group>
                              </Row>
                            </div>
                          </div>
                          <hr />
                        </div>
                      ))}
                    </Row>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Row>
      <Row>
        <div className="col-lg-12">
          <div className="card shadow mb-1">
            <div className="card-header">
              <b>Credenciamento</b>
            </div>
            <div className="card-body">
              <div className="col-sm-12">
                <Row>
                  <div className="col-sm-12">
                    {credenciamentoModels?.map((obj) => (
                      <Row>
                        <Form.Group as={Col} sm={12} md={6}>
                          <div className="form-inline">
                            <Form.Label>{obj?.dsCredenciamento}</Form.Label>
                          </div>
                        </Form.Group>
                      </Row>
                    ))}
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Row>
      <Row>
        <div className="col-lg-12">
          <div className="card shadow mb-1">
            <div className="card-header">
              <b>Outras Empresas</b>
            </div>
            <div className="card-body">
              <div className="col-sm-12">
                <Row>
                  <div className="col-sm-12">
                    {outrasEmpresasModels?.map((obj) => (
                      <Row>
                        <Form.Group as={Col} sm={12} md={6}>
                          <div className="form-inline">
                            <Form.Label>{obj?.cnpjIe ? obj?.cnpjIe : "NÃO CONSTA EMPRESA"}</Form.Label>
                          </div>
                        </Form.Group>
                      </Row>
                    ))}
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Row>
      <Row>
        <div className="col-lg-12">
          <div className="card shadow mb-1">
            <div className="card-header">
              <b>Ocorrências Fiscais</b>
            </div>
            <div className="card-body">
              <div className="col-sm-12">
                <Row>
                  <div className="col-sm-12">
                    {ocorrenciasFiscaisModels?.map((obj) => (
                      <Row>
                        <Form.Group as={Col} sm={12} md={5}>
                          <div className="form-inline">
                            <Form.Label>{obj?.descricao}</Form.Label>
                          </div>
                        </Form.Group>
                        <Form.Group as={Col} sm={12} md={6}>
                          <div className="form-inline">
                            <Form.Label>
                              <DateTime value={obj?.dsocDatai} stringFormat="dd/MM/yyyy" />
                            </Form.Label>
                          </div>
                        </Form.Group>
                      </Row>
                    ))}
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Row>
    </>
  );
};

export default ConsultaContribuinte;
